module.exports = __webpack_public_path__ + "fonts/PayPal.d394222a0e3c3db0b8930e0c3aecf275.svg";